module.exports = __webpack_public_path__ + "assets/img/text-vision.fc19a52a.svg";